import { render, staticRenderFns } from "./CompanyGroups.vue?vue&type=template&id=11915140"
import script from "./CompanyGroups.vue?vue&type=script&lang=js"
export * from "./CompanyGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports